import DG_Form from "../../../../custom/data-entry/form";
import Content from "./content";
import {useParams} from "react-router-dom";
import {Form} from "antd";
import {useState} from "react";
import moment from "moment";
import {addWeightSlip} from "../../../../api/weightSlip";
import {useDispatch, useSelector} from "react-redux";
import {onChangeVisibleDrawer, onReloadData} from "../../../../redux/actions/layout/interaction/action";

const Add = ({databaseKey}) =>{

    const dispatch = useDispatch()
    const {reloadData} = useSelector(state => state.layoutInteractionReducer)

    const {code} = useParams()
    const [form] = Form.useForm()
    const [gioKTai , setGioKTai] = useState(moment())
    const [gioCTai , setGioCTai] = useState(moment())
    const onFinish = (value) => {

        value = {
            ...value,
            gioKTai: value.gioKTai.format("YYYY-MM-DDTHH:mm:ss"),
            gioCoTai: value.gioCoTai.format("YYYY-MM-DDTHH:mm:ss"),
            ngayCan: value.ngayCan.format("YYYY-MM-DDTHH:mm:ss"),
        }

        addWeightSlip(databaseKey, value ).then(r =>{
            dispatch(onChangeVisibleDrawer(false))
            dispatch(onReloadData(!reloadData))
        })
            .catch(()=>{})
    }

    return (
         <>
            <h1 className={"flex justify-center text-4xl mb-6"}> Phiếu cân xe </h1>
            <DG_Form
                name="basic"
                labelCol={{ span: 8 }}
                wrapperCol={{ span: 16 }}
                autoComplete="off"
                form={form}
                mode={"add"}
                onFinish={onFinish}
                colon={false}
                labelAlign="left"
                scrollToFirstError={true}
            >
                <Content form={form}
                         code={code}
                         gioKTai={gioKTai}
                         setGioKTai={(value)=>setGioKTai(value)}
                         gioCTai={gioCTai}
                         setGioCTai={(value)=>setGioCTai(value)}/>
            </DG_Form>
        </>
    )
}

export default Add
